
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook qui gère le titre de la page dynamiquement
 * @param defaultTitle Titre par défaut à utiliser si aucun titre spécifique n'est trouvé
 */
export const useDocumentTitle = (defaultTitle: string = 'Scaloo') => {
  const location = useLocation();
  
  useEffect(() => {
    let title = defaultTitle;
    
    // Déterminer le titre en fonction du chemin actuel
    if (location.pathname.startsWith('/dashboard')) {
      title = `Dashboard | ${defaultTitle}`;
    } else if (location.pathname.includes('/products/')) {
      title = `Produit | ${defaultTitle}`;
    } else if (location.pathname === '/login') {
      title = `Connexion | ${defaultTitle}`;
    } else if (location.pathname === '/register') {
      title = `Inscription | ${defaultTitle}`;
    } else if (location.pathname === '/plans') {
      title = `Plans & Tarifs | ${defaultTitle}`;
    } else if (location.pathname === '/') {
      title = `Accueil | ${defaultTitle}`;
    }
    
    // Mettre à jour le titre du document
    document.title = title;
    
  }, [location.pathname, defaultTitle]);
};
